import React from 'react';

const kf = `
  @keyframes tickerScroll {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }
  @keyframes tickerPulse {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.25; }
  }
`;

export default function NewsTicker({ headlines }) {
  if (!headlines || headlines.length === 0) return null;

  // Double items for seamless infinite loop
  const items = [...headlines, ...headlines];
  const duration = Math.max(headlines.length * 7, 40);

  return (
    <div style={{
      position: 'relative',
      height: 38,
      background: '#080808',
      borderTop: '1px solid #161616',
      borderBottom: '1px solid #161616',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      marginBottom: 28,
      flexShrink: 0,
    }}>
      <style>{kf}</style>

      {/* Pinned label */}
      <div style={{
        position: 'relative',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        padding: '0 14px 0 16px',
        height: '100%',
        background: '#080808',
        borderRight: '1px solid #161616',
        flexShrink: 0,
      }}>
        <span style={{
          width: 6, height: 6, borderRadius: '50%',
          background: '#e8002d', display: 'inline-block', flexShrink: 0,
          animation: 'tickerPulse 1.6s ease-in-out infinite',
        }} />
        <span style={{
          fontFamily: 'var(--font-display)',
          fontSize: 11, fontWeight: 700,
          color: '#e8002d',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}>
          F1 News
        </span>
      </div>

      {/* Scrolling strip */}
      <div style={{
        flex: 1,
        overflow: 'hidden',
        maskImage: 'linear-gradient(to right, transparent, black 4%, black 88%, transparent)',
        WebkitMaskImage: 'linear-gradient(to right, transparent, black 4%, black 88%, transparent)',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          width: 'max-content',
          animation: `tickerScroll ${duration}s linear infinite`,
        }}>
          {items.map((item, i) => (
            <React.Fragment key={i}>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: 'var(--font-mono)',
                  fontSize: 11,
                  color: '#666',
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  padding: '0 4px',
                  transition: 'color 0.15s',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.color = '#d0d0d0';
                  e.currentTarget.parentElement.style.animationPlayState = 'paused';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.color = '#666';
                  e.currentTarget.parentElement.style.animationPlayState = 'running';
                }}
              >
                {item.title}
              </a>
              <span style={{
                fontFamily: 'var(--font-mono)',
                color: '#222',
                fontSize: 16,
                padding: '0 16px',
                flexShrink: 0,
                userSelect: 'none',
              }}>
                ·
              </span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
